import classNames from 'classnames'
import { ThumbnailOptionType } from 'dummy/data'
import { useEffect, useRef, useState } from 'react'
import { AiThumbnailTitle, LinkDetailType, ThumbnailType } from 'service/list'
import {
  CHANNEL_NAME_PATTERN,
  getLocalStorage,
  initialThumbnailOption,
  THUMBNAIL_PATTERN,
} from 'utils/common'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { ReactComponent as DownloadSVG } from 'svg/download.svg'
import { Controller } from 'react-hook-form'
import { InputThumbnail } from 'components/atom/Input'
import { TextArea } from 'components/atom/TextArea'
import { Me } from 'service/user'
import { isMobile } from 'react-device-detect'
import { CircularCheckbox } from 'components/CircularCheckbox'
import { PlanTag } from 'components/planTag'
import { ThumbnailImgComponent } from 'pages/content-video-editor/components/shortvideo/ThumbnailImgComponent'
import { ImageComponents } from 'components/atom/ImageComponents'
import ProgressBar from 'components/progressbar/ProgressBar'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../../App.css'
export const AiMethodThumbnail = (props: any) => {
  const {
    selectedLinks,
    setValue,
    watch,
    thumbnailList,
    userInfo,
    translatePlanName,
    control,
    aiRecommendThumbnailTitle,
    isAiName,
    isRememberChannel,
    setIsRememberChannel,
    placIdThumbnail,
    setPlacIdThumbnail,
    setSelectedItem,
    isSaveThumbnail,
    setIsSaveThumbnail,
    selectedImgSrc,
    setSelectedImgSrc,
    selectedPlacIdThumbnail,
    setSelectedPlacIdThumbnail,
    handleCreateThumbnail,
    imgIsPending,
    createThumbnailPending,
    handleRefetchImgDataById,
    placIdThumbnailRef,
  } = props

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
  }
  const [currentPlacId, setCurrentPlacId] = useState<number>(0)

  const channel = getLocalStorage('channel')

  const [thumbnailImgArr, setThumbnailImgArr] = useState<string[]>([])
  const [thumbnailStatus, setThumbnailStatus] = useState<boolean[]>(
    new Array(thumbnailList?.length).fill(false),
  )
  const [isTitleCheck, setTitleCheck] = useState<boolean>(false)
  const [selectedThumbnail, setSelectedThumbnail] = useState<ThumbnailType>()
  const thumbnailRefs = useRef<(HTMLDivElement | null)[]>([])
  const [thumbnailType, setThumbnailType] = useState<ThumbnailOptionType>(
    initialThumbnailOption,
  )

  const sliderRef = useRef<any>(null)

  const handleSelectThumbnailImg = (path: string, index: number) => {
    setSelectedImgSrc(path)
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index) // 클릭한 비디오의 인덱스로 슬라이드 이동
    }
  }

  const handleTitleCheckBox = (flag: boolean) => {
    if (flag) {
      setValue('thumbnailInfo.title1', ' ')
      setValue('thumbnailInfo.title2', ' ')
      setValue('thumbnailInfo.title3', ' ')
    } else {
      setValue('thumbnailInfo.title1', '')
      setValue('thumbnailInfo.title2', '')
      setValue('thumbnailInfo.title3', '')
    }
  }

  const handleThumbnail = (index: number, thumbnail: ThumbnailType) => {
    const updatedThumbnailState = thumbnailStatus.map((value, idx) =>
      idx === index ? true : false,
    )
    setValue('thumbnailId', thumbnail.id)
    setThumbnailStatus(updatedThumbnailState)
    setSelectedThumbnail(thumbnail)
    setIsSaveThumbnail(false)
    setSelectedItem(thumbnail)
    // setThumbnailCheckModal(false)
  }

  const renderThumbnailTitleDivByTitleLineCnt = () => {
    const titleLines = selectedThumbnail?.titleLines ?? 0

    return (
      <>
        <div className="title flex flex-col gap-2">
          <span className="inline-flex w-[90px] gap-1 rounded-[4px] bg-black p-1 text-[12px] font-bold text-white">
            <StarIcon />
            AI 생성 제목
          </span>
          <div className="flex flex-wrap gap-2">
            {titleLines === 1
              ? (
                  aiRecommendThumbnailTitle as AiThumbnailTitle
                )?.thumbnailTitles.map((el) => (
                  <button
                    className={classNames('rounded-[4px] px-2 py-1', {
                      'bg-[#EEF1F7] hover:bg-[#BBEBEC]':
                        watch('thumbnailInfo.title1') !== el.substring(0, 20),
                      'bg-[#BBEBEC]':
                        watch('thumbnailInfo.title1') === el.substring(0, 20),
                    })}
                    type="button"
                    onClick={() => {
                      if (!isTitleCheck) {
                        setValue('thumbnailInfo.title1', el.substring(0, 20))
                      }
                    }}
                  >
                    {`${el.substring(0, 20)}`}
                  </button>
                ))
              : (
                  aiRecommendThumbnailTitle as AiThumbnailTitle
                )?.thumbnailTitlesSplit.map((el) => (
                  <button
                    className={classNames('rounded-[4px] px-2 py-1 text-left', {
                      'bg-[#EEF1F7] hover:bg-[#BBEBEC]':
                        watch('thumbnailInfo.title1') !== el.substring(0, 20),
                      'bg-[#BBEBEC]':
                        watch('thumbnailInfo.title1') === el.substring(0, 20),
                    })}
                    type="button"
                    onClick={() => {
                      if (!isTitleCheck) {
                        setValue('thumbnailInfo.title1', el.substring(0, 20))
                      }
                    }}
                  >
                    {el
                      .substring(0, 21)
                      .split('\n')
                      .map((el) => {
                        return (
                          <>
                            {el} <br />
                          </>
                        )
                      })}
                  </button>
                ))}
          </div>
          <div className="">
            <Controller
              key="title"
              render={({ field }) => {
                const handleInput = (
                  e: React.ChangeEvent<HTMLTextAreaElement>,
                ) => {
                  const value = e.target.value
                  const lines = value.split('\n').length

                  // 줄 수가 4줄을 초과하면 입력 무시

                  if (lines > 4) {
                    const trimmedValue = value
                      .split('\n')
                      .slice(0, 4)
                      .join('\n')

                    field.onChange(trimmedValue) // 강제로 잘라서 저장
                  } else {
                    field.onChange(value) // 정상 입력
                  }
                }
                return (
                  <>
                    {titleLines === 1 ? (
                      <>
                        {' '}
                        <InputThumbnail
                          {...field}
                          maxLength={20}
                          disabled={isTitleCheck}
                          placeholder={
                            '디자인에 어울리는 글자수로 제목을 입력하세요!'
                          }
                          width="w-full"
                        />
                      </>
                    ) : (
                      <>
                        <TextArea
                          {...field}
                          maxLength={20}
                          placeholder={
                            '디자인에 어울리는 글자수로 제목을 입력하세요!'
                          }
                          bg={true}
                          width="w-full"
                          onInput={handleInput}
                          disabled={isTitleCheck}
                        />
                      </>
                    )}
                    <div
                      className={`mb-1 flex gap-[4px] ${
                        !THUMBNAIL_PATTERN.test(field.value) && 'text-error'
                      }`}
                    >
                      <span>{field.value.length}/20</span>
                      <span
                        className={classNames('', {})}
                      >{`이모지는 허용되지 않습니다.`}</span>
                    </div>
                  </>
                )
              }}
              name={`thumbnailInfo.title1`}
              control={control}
              rules={{
                required: {
                  value:
                    watch('thumbnailInfo.title1') ||
                    watch('thumbnailInfo.title2')
                      ? false
                      : true,
                  message: '썸네일 내용은 필수입니다!',
                },

                validate: (value) => {
                  return (
                    THUMBNAIL_PATTERN.test(value) ||
                    '이모지는 허용되지 않습니다.'
                  )
                },
              }}
            />
          </div>
        </div>
        <div className="subtitle mt-5 flex flex-col gap-2">
          <span className="inline-flex w-[100px] gap-1 rounded-[4px] bg-black p-1 text-[12px] font-bold text-white">
            <StarIcon />
            AI 생성 부제목
          </span>
          <div className="flex flex-wrap gap-2">
            {(
              aiRecommendThumbnailTitle as AiThumbnailTitle
            )?.thumbnailSubtitles.map((el) => (
              <button
                className={classNames('rounded-[4px] px-2 py-1 text-left', {
                  'bg-[#EEF1F7] hover:bg-[#BBEBEC]':
                    watch('thumbnailInfo.title2') !== el.substring(0, 30),
                  'bg-[#BBEBEC]':
                    watch('thumbnailInfo.title2') === el.substring(0, 30),
                })}
                type="button"
                onClick={() => {
                  setValue('thumbnailInfo.title2', el.substring(0, 30))
                }}
              >
                {`${el.substring(0, 30)}`}
              </button>
            ))}
          </div>
          <div className="">
            <Controller
              key="subtitle"
              render={({ field }) => (
                <>
                  <InputThumbnail
                    {...field}
                    maxLength={30}
                    placeholder={
                      '디자인에 어울리는 글자수의 부제목을 입력하세요!'
                    }
                    width="w-full"
                    disabled={isTitleCheck}
                  />

                  <div
                    className={`mb-1 flex gap-[4px] ${
                      !THUMBNAIL_PATTERN.test(field.value) && 'text-error'
                    }`}
                  >
                    <span>{field.value.length}/30</span>
                    <span
                      className={classNames('', {})}
                    >{`이모지는 허용되지 않습니다.`}</span>
                  </div>
                </>
              )}
              name={`thumbnailInfo.title2`}
              control={control}
              rules={{
                required: {
                  value:
                    watch('thumbnailInfo.title1') ||
                    watch('thumbnailInfo.title2')
                      ? false
                      : true,
                  message: '썸네일 내용은 필수입니다!',
                },

                validate: (value) => {
                  return (
                    THUMBNAIL_PATTERN.test(value) ||
                    '이모지는 허용되지 않습니다.'
                  )
                },
              }}
            />
          </div>
        </div>
      </>
    )
  }

  const handleSelectThumbnailIdByPlan = () => {
    if ((userInfo as Me) && thumbnailList) {
      const planName = userInfo?.subscriptions?.planName
      const list = thumbnailList as ThumbnailType[]
      let thumbnail: any = null
      switch (planName) {
        case '무료':
          // thumbnail = list.filter((el) => el.planName === '프리미엄')
          thumbnail = list.filter((el) => el.planName === '프로')
          break
        case '라이트':
          thumbnail = list.filter((el) => el.planName === '라이트')
          break
        case '프로':
          thumbnail = list.filter((el) => el.planName === '프로')
          break
        case '프리미엄':
          thumbnail = list.filter((el) => el.planName === '프로')
          // thumbnail = list.filter((el) => el.planName === '프리미엄')
          break
        default:
          break
      }
      return thumbnail
    }
  }

  /**
   * 모달에 들어왔을때 자동으로
   * 플랜 별로 기본적인 thumbnailId가 지정이 되어야함
   * 라이트 기본 / 현재는 map에서 걸리는 젤 첫번째를 확인
   * 프로 기본 / 현재는 map에서 걸리는 젤 첫번째를 확인
   * 프리미엄 기본 / 현재는 map에서 걸리는 젤 첫번째를 확인
   */
  useEffect(() => {
    if ((userInfo as Me) && thumbnailList) {
      const planName = userInfo?.subscriptions?.planName
      const list = thumbnailList as ThumbnailType[]
      let thumbnail: any = null
      switch (planName) {
        case '체험':
          // thumbnail = list.filter((el) => el.planName === '프리미엄')
          thumbnail = list.filter((el) => el.planName === '프로')
          break
        case '라이트':
          thumbnail = list.filter((el) => el.planName === '라이트')
          break
        case '프로':
          thumbnail = list.filter((el) => el.planName === '프로')
          break
        case '프리미엄':
          thumbnail = list.filter((el) => el.planName === '프로')
          // thumbnail = list.filter((el) => el.planName === '프리미엄')
          break
        default:
          break
      }
      console.log(thumbnail, 'thumbnail')
      if (thumbnail && !isSaveThumbnail) {
        let index = 0
        list.forEach((el, i) => {
          if (el.id === thumbnail[0].id) {
            index = i
          }
        })
        const updatedThumbnailState = thumbnailStatus.map((value, idx) =>
          idx === index ? true : false,
        )
        setThumbnailStatus(updatedThumbnailState)

        setSelectedItem(thumbnail[0])
        setSelectedThumbnail(thumbnail[0])
        setValue('thumbnailId', thumbnail[0].id)
      }
    }
  }, [thumbnailList])

  /**
   * AI추천 상품 true일때
   * 자동으로 값을 넣어주기
   */

  useEffect(() => {
    console.log('AI 생성 상품 title/subtitle')
    const selectedThumbnailId = watch('thumbnailId')
    if (
      isAiName &&
      aiRecommendThumbnailTitle &&
      selectedThumbnailId !== 0 &&
      !isTitleCheck &&
      !isSaveThumbnail
    ) {
      // 자동으로 들어가기위해서 썸네일이 자동으로 선택되는게 먼저 선행되어야한다.
      const titleLines = selectedThumbnail?.titleLines ?? 1

      if (titleLines === 1) {
        setValue(
          'thumbnailInfo.title1',
          aiRecommendThumbnailTitle?.thumbnailTitles[0],
        )
      } else if (titleLines === 3) {
        setValue(
          'thumbnailInfo.title1',
          aiRecommendThumbnailTitle?.thumbnailTitlesSplit[0],
        )
      }
      setValue(
        'thumbnailInfo.title2',
        aiRecommendThumbnailTitle?.thumbnailSubtitles[0],
      )
    }
  }, [isAiName, aiRecommendThumbnailTitle, selectedThumbnail])

  /**
   * 선택된 값들이 있으면
   */

  useEffect(() => {
    if (channel) {
      setValue('thumbnailInfo.channelName', channel)
      setIsRememberChannel(true)
    }
    if (isSaveThumbnail) {
      // 저장기록을 한번 remind해줘야함
      setValue('thumbnailInfo.title1', watch('thumbnailInfo.title1'))
      setValue('thumbnailInfo.title2', watch('thumbnailInfo.title2'))
      setValue('thumbnailInfo.title3', watch('thumbnailInfo.title3'))
      setValue('thumbnailId', watch('thumbnailId'))
      setValue('thumbnailHistoryId', watch('thumbnailHistoryId'))
      const [thumbnail] = thumbnailList?.filter(
        (el: ThumbnailType) => el.id === watch('thumbnailId'),
      )
      const [placidThumbnail] = placIdThumbnail?.filter(
        (el: ThumbnailType) => el.id === watch('thumbnailHistoryId'),
      )

      let index = 0
      thumbnailList?.forEach((el: any, i: number) => {
        if (el?.id === thumbnail?.id) {
          index = i
        } else {
          const thumbnail = handleSelectThumbnailIdByPlan()
        }
      })
      const updatedThumbnailState = thumbnailStatus.map((value, idx) =>
        idx === index ? true : false,
      )
      setThumbnailStatus(updatedThumbnailState)
      setSelectedThumbnail(thumbnail)
      setSelectedPlacIdThumbnail(placidThumbnail)
    }
  }, [channel])

  useEffect(() => {
    if (selectedLinks) {
      let imgArr: string[] = []
      selectedLinks?.forEach((element: LinkDetailType) => {
        imgArr = [...imgArr, ...element.video.thumbnail_images]
      })
      setThumbnailImgArr(imgArr)
      setSelectedImgSrc(imgArr[0])
    }
  }, [selectedLinks])

  return (
    <>
      <div className="">
        <div className={classNames('rounded-[10px] bg-[#F6F8FB] p-4', {})}>
          <p
            className={classNames('font-bold', {
              'text-left text-[18px]': !isMobile,
              'text-[24px]': isMobile,
            })}
          >
            썸네일 디자인{' '}
          </p>
          <div
            className={classNames('mt-3 flex gap-1', {
              'h-[190px] flex-row': !isMobile,
              'flex-col': isMobile,
            })}
          >
            <div
              className={classNames('', {
                'w-[50%]': !isMobile,
                'h-[190px] w-full': isMobile,
              })}
            >
              <img
                src={selectedThumbnail?.path ?? thumbnailList[0]?.path}
                alt=""
                className="h-[190px] w-full"
              />
            </div>
            <div
              className={classNames('overflow-y-auto bg-[#2E343D] p-4', {
                'w-[50%]': !isMobile,
                'h-[190px] w-full': isMobile,
              })}
            >
              <div className="flex justify-between font-bold">
                <p className="text-white">썸네일 디자인을 선택해주세요</p>
                <p className="text-white">
                  총 <span className="text-main">{thumbnailList?.length}</span>
                </p>
              </div>
              <div className="mt-2 grid grid-cols-3 gap-2">
                {thumbnailList?.map(
                  (thumbnail: ThumbnailType, index: number) => (
                    <div
                      className={`relative flex gap-[24px] md:flex-col md:gap-2 ${thumbnail?.name} `}
                      key={index}
                      ref={(el) => (thumbnailRefs.current[index] = el)}
                      onClick={() => {
                        if (thumbnail.usable) {
                          handleThumbnail(index, thumbnail)
                        }
                      }}
                    >
                      <PlanTag
                        planName={translatePlanName(thumbnail.planName)}
                        className="absolute left-1 top-1 z-50"
                      />
                      <ThumbnailImgComponent
                        thumbnail={thumbnail}
                        index={thumbnailStatus[index]}
                        className={`h-[59x] w-[105px]`}
                      />
                      <div
                        className={`absolute flex items-center gap-[8px] ${thumbnail?.name} -right-1 bottom-1`}
                      >
                        <Controller
                          render={({ field }) => (
                            <CircularCheckbox
                              {...field}
                              id={index}
                              checked={watch('thumbnailId') === thumbnail.id}
                              disabled={!userInfo || !thumbnail?.usable}
                              onChange={() => {}}
                            />
                          )}
                          name="thumbnailId"
                          control={control}
                        />
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>

          <p
            className={classNames(
              'mt-3 flex items-center justify-between text-left',
              {
                'flex-row': !isMobile,
                'flex-col': isMobile,
              },
            )}
          >
            썸네일에 사용할 이미지를 선택해주세요.
            <p
              className={classNames('font-bold', {
                'w-full text-left': isMobile,
              })}
            >
              총{' '}
              <span className="font-bold text-main">
                {thumbnailImgArr.length}개
              </span>
            </p>
          </p>
          {isMobile ? (
            <>
              {' '}
              <div className="mt-2 grid grid-cols-3 gap-[6.5px] rounded-[10px]">
                {thumbnailImgArr.map((imgPath, index) => (
                  <div
                    className="relative flex-none"
                    key={index}
                    onClick={() => {
                      handleSelectThumbnailImg(imgPath, index)
                    }}
                  >
                    {' '}
                    <img
                      src={imgPath}
                      alt=""
                      className={classNames('', {
                        'h-[132px] w-[132px] rounded-[4px]': !isMobile,
                        'h-[110px] w-[110px] rounded-[4px]': isMobile,
                      })}
                    />
                    <span className="absolute bottom-1 right-1">
                      <CircularCheckbox
                        id={index}
                        onChange={() => {}}
                        checked={imgPath === selectedImgSrc}
                      />
                    </span>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              {' '}
              <div className="bg-[#D9DEE8 pb-6">
                <Slider {...settings} className="">
                  {thumbnailImgArr.map((imgPath, index) => (
                    <div
                      className="relative flex-none"
                      key={index}
                      onClick={() => {
                        handleSelectThumbnailImg(imgPath, index)
                      }}
                    >
                      {' '}
                      <img
                        src={imgPath}
                        alt=""
                        className="h-[132px] w-[132px] rounded-[4px]"
                      />
                      <span className="absolute bottom-2 right-3">
                        <CircularCheckbox
                          id={index}
                          onChange={() => {}}
                          checked={imgPath === selectedImgSrc}
                        />
                      </span>
                    </div>
                  ))}
                </Slider>
              </div>
            </>
          )}
          {/* <div className="flex  bg-[#EEF1F7] px-4 py-[10px] mt-2 rounded-[10px] items-center gap-4">
              <div className="flex relative w-[64px] h-[64px] bg-[#D9DEE8]">
                {watch('thumbnailInfo.thumbnailFile', []).map(
                  (file: any, fileIndex: number) => (
                    <div
                      style={{
                        width: '64px',
                        height: '64px',
                        overflow: 'hidden',
                        position: 'relative',
                      }}
                    >
                      <img
                        style={{
                          width: '64px',
                          height: '64px',
                          position: 'absolute',
                          objectFit: 'cover',
                          overflow: 'hidden',
                        }}
                        src={URL.createObjectURL(file)}
                        alt="thumbnail"
                      />
                      <button
                        // onClick={handleRemoveImage}
                        className="absolute top-2 right-2"
                        style={{ cursor: 'pointer' }}
                      >
                        <img
                          className="w-[24px] h-[24px]  md:w-[32px] md:h-[32px]"
                          src="assets/img/icon_circle_x_black.png"
                          alt="x"
                        />
                      </button>
                    </div>
                  )
                )}
              </div>
              <div className="flex flex-col">
                <button
                  onClick={(event) => {
                    event.preventDefault() // 기본 form 제출 동작을 방지
                    document.getElementById(`file-input`)?.click() // 파일 선택 창 열기
                  }}
                  type="button"
                  className="flex items-center justify-center w-[122px] h-[36px] text-white rounded-full bg-[#6B8ACB] text-[14px] font-bold mb-1"
                >
                  <img
                    src="assets/img/icon_image.png"
                    alt=""
                    width={17}
                    className="mr-[6px]"
                  />
                  <span>파일 업로드</span>
                </button>
                <input
                  id={`file-input`}
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  className="hidden"
                  // onChange={(e) => handleFileChange(e)}
                />
                <p className="text-[#8F929B] text-[14px]  text-left ">
                  권장 사이즈 1280x720, 최대 2MB | jpg, jpeg, png
                </p>
              </div>
            </div> */}
        </div>
        <div
          className={classNames(
            'mt-6 flex flex-col gap-4 rounded-[10px] bg-[#F6F8FB] p-4',
            { 'mt-10': isMobile },
          )}
        >
          <div className="flex flex-col">
            <p
              className={classNames('', {
                'text-left text-[18px] font-bold': !isMobile,
                'text-center text-[24px] font-bold': isMobile,
              })}
            >
              썸네일 텍스트 입력
            </p>
            <div className="mt-[8px] flex items-center gap-[6px] text-[#8F929B]">
              <input
                type="checkbox"
                className="h-[20px] w-[20px] border border-[#8F929B]"
                checked={isTitleCheck}
                onClick={() => {
                  setTitleCheck(!isTitleCheck)
                  handleTitleCheckBox(!isTitleCheck)
                }}
              />
              <p style={{ fontWeight: 500 }} className="text-error">
                썸네일에 텍스트 넣지 않기
              </p>
            </div>
          </div>
          <div className="flex flex-col">
            {renderThumbnailTitleDivByTitleLineCnt()}
          </div>
        </div>
        <div
          className={classNames(
            'mt-6 flex h-auto flex-col justify-center gap-1 rounded-[10px] p-5',
            {
              'bg-[#F6F8FB]': !isMobile,
              'bg-white': isMobile,
            },
          )}
        >
          <div className="flex w-full flex-col justify-start">
            {' '}
            {isMobile ? (
              <>
                {' '}
                <p className="text-center text-[24px] font-bold">
                  채널 이름 입력
                </p>{' '}
                <span className="text-left text-[14px] text-[#8F929B]">
                  썸네일 왼쪽 상단에 들어갈 유튜브 채널 이름을 입력 해주세요
                </span>
              </>
            ) : (
              <>
                {' '}
                <p className="text-left font-bold">
                  채널 이름 입력(선택사항){' '}
                  <span className="text-left text-[14px] text-[#8F929B]">
                    썸네일 왼쪽 상단에 들어갈 유튜브 채널 이름을 입력 해주세요
                  </span>
                </p>
              </>
            )}
            <div className="mt-2 flex items-center gap-[6px] text-[#8F929B]">
              <input
                type="checkbox"
                className="h-[20px] w-[20px] border border-[#8F929B]"
                checked={isRememberChannel}
                onClick={() => {
                  setIsRememberChannel((prev: boolean) => !prev)
                }}
              />
              <p style={{ fontWeight: 500 }} className="text-[14px] text-main">
                저장된 채널 이름 항상 넣기
              </p>
            </div>
          </div>
          <div className="mt-4">
            <Controller
              key={`thumbnailInfo.channelName`}
              render={({ field }) => (
                <>
                  <InputThumbnail
                    {...field}
                    error={
                      field.value.length > 30 ||
                      !CHANNEL_NAME_PATTERN.test(field.value)
                        ? true
                        : false
                    }
                    placeholder="운영하시는 유튜브 채널 이름을 입력해주세요 (30자 이내)"
                    maxLength={30}
                    width={'w-full'}
                  />
                  <div
                    className={`mt-[8px] flex gap-[4px] ${
                      (field.value.length > 30 ||
                        !CHANNEL_NAME_PATTERN.test(field.value)) &&
                      'text-error'
                    }`}
                  >
                    <span>{field.value.length}/30</span>
                    <span>{`이모지는 허용되지 않습니다.`}</span>
                  </div>
                  {/* 채널이름 미설정 체크박스  */}
                </>
              )}
              name={`thumbnailInfo.channelName`}
              control={control}
              rules={{
                maxLength: {
                  value: 30,
                  message: '채널이름 내용의 길이가 30자를 넘습니다.',
                },
                validate:
                  watch(`thumbnailInfo.channelName`) !== ''
                    ? (value) => {
                        return (
                          CHANNEL_NAME_PATTERN.test(value) ||
                          '이모지와 &는 허용되지 않습니다.'
                        )
                      }
                    : undefined,
              }}
            />
            {/* <div className="flex items-center gap-3 mt-[8px] text-error">
                        <input
                          type="checkbox"
                          className="w-[20px] h-[20px] border border-[#8F929B]"
                          checked={isCheck}
                          onClick={() => {
                            setValue('thumbnailInfo.channelName', '')
                            setEmptyChannelName('')
                            setCheck((prev) => !prev)
                          }}
                        />
                        <p style={{ fontWeight: 500 }} className="text-[14px]">
                          채널 이름 넣지 않기
                        </p>
                      </div> */}
          </div>
        </div>

        <div
          className="mt-10 flex w-full flex-col items-center justify-center"
          ref={placIdThumbnailRef}
        >
          <button
            className={classNames(
              'flex h-[60px] items-center justify-center gap-1 rounded-full bg-[#2E343D] font-bold text-white disabled:opacity-30',
              {
                'w-[380px]': !isMobile,
                'w-[343px]': isMobile,
              },
            )}
            type="button"
            disabled={
              placIdThumbnail.length === 3 ||
              imgIsPending ||
              createThumbnailPending
            }
            onClick={() => {
              handleCreateThumbnail()
            }}
          >
            <StarIcon /> 썸네일 생성하기 {`${placIdThumbnail.length}/3`}{' '}
            <span className="h-[18px] w-[40px] rounded-[6px] bg-[#FD6767] text-[12px]">
              할인중
            </span>
          </button>
          <p className="text-[14px] text-[#8F929B]">
            썸네일 생성은 최대 3회까지 가능합니다.
          </p>
        </div>
        {isMobile ? (
          <>
            {' '}
            <div className="my-10 flex h-auto flex-col gap-6 py-6">
              <p className="font-bold">사용하실 썸네일을 1개 선택해주세요!</p>
              <div className="flex flex-col gap-6">
                <div className="h-[210px] w-full bg-[#D9DEE8]">
                  {selectedPlacIdThumbnail &&
                    !createThumbnailPending &&
                    !imgIsPending && (
                      <>
                        {selectedPlacIdThumbnail?.path !== '' ? (
                          <>
                            <img
                              src={selectedPlacIdThumbnail?.path}
                              alt="thumbnail"
                              className="h-[210px] w-full"
                            />
                          </>
                        ) : (
                          <>
                            <div
                              className="flex h-full w-full flex-col items-center"
                              style={{
                                background: 'rgba(0,0,0,0.6)',
                              }}
                            >
                              <p className="pt-[58px] text-white">
                                🤗 <br /> 아래 버튼을 클릭해서
                                <br /> 생성된 썸네일 이미지를 불러오세요!
                              </p>
                              <button
                                className="mt-6 flex w-[140px] items-center gap-1 rounded-full px-[13.5px] py-[8.75px] text-[14px] text-white"
                                style={{
                                  background: 'rgba(0,0,0,0.6)',
                                }}
                                type="button"
                                onClick={() => {
                                  handleRefetchImgDataById(
                                    selectedPlacIdThumbnail.id,
                                  )
                                }}
                              >
                                <DownloadSVG />
                                이미지 불러오기
                              </button>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  {createThumbnailPending ||
                    (imgIsPending && (
                      <>
                        <div className="flex h-[210px] w-full flex-col items-center justify-center gap-2 bg-[#D9DEE8] px-2">
                          <p className="text-[14px]">썸네일 이미지 생성중...</p>
                          <div className="w-[136px]">
                            <ProgressBar />
                          </div>
                        </div>
                      </>
                    ))}
                </div>
                <div className="flex gap-1">
                  {placIdThumbnail.map((el: ThumbnailType, index: number) => (
                    <div
                      className="relative"
                      onClick={() => {
                        setSelectedPlacIdThumbnail(el)
                        setValue('thumbnailHistoryId', el?.id)
                      }}
                    >
                      <ImageComponents
                        className="relative h-[68px] w-[122px]"
                        index={selectedPlacIdThumbnail?.id === el.id}
                        path={el.path}
                      />
                      <div className="absolute bottom-1 right-0">
                        <Controller
                          render={({ field }) => (
                            <CircularCheckbox
                              {...field}
                              id={index}
                              // checked={watch('thumbnailId') === thumbnail.id}
                              // disabled={!userInfo || !thumbnail?.usable}
                              checked={selectedPlacIdThumbnail?.id === el.id}
                              onChange={() => {}}
                            />
                          )}
                          name="thumbnailId"
                          control={control}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {' '}
            <div className="my-10 flex h-[345px] flex-col gap-6 bg-[#F6F8FB] px-[60px] py-6">
              <p className="font-bold">사용하실 썸네일을 1개 선택해주세요!</p>
              <div className="flex gap-6">
                {selectedPlacIdThumbnail &&
                  !createThumbnailPending &&
                  !imgIsPending && (
                    <div className="h-[254px] w-[452px] bg-[#D9DEE8]">
                      {selectedPlacIdThumbnail?.path !== '' ? (
                        <img
                          src={selectedPlacIdThumbnail?.path}
                          alt="thumbnail"
                          className="h-[254px] w-[452px]"
                        />
                      ) : (
                        <div
                          className="flex h-full w-full flex-col items-center"
                          style={{
                            background: 'rgba(0,0,0,0.6)',
                          }}
                        >
                          <p className="pt-[58px] text-white">
                            🤗 <br /> 아래 버튼을 클릭해서
                            <br /> 생성된 썸네일 이미지를 불러오세요!
                          </p>
                          <button
                            className="mt-6 flex w-[140px] items-center gap-1 rounded-full px-[13.5px] py-[8.75px] text-[14px] text-white"
                            style={{
                              background: 'rgba(0,0,0,0.6)',
                            }}
                            type="button"
                            onClick={() => {
                              handleRefetchImgDataById(
                                selectedPlacIdThumbnail.id,
                              )
                            }}
                          >
                            <DownloadSVG />
                            이미지 불러오기
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                {createThumbnailPending ||
                  (imgIsPending && (
                    <>
                      <div className="flex h-[254px] w-[452px] flex-col items-center justify-center gap-2 bg-[#D9DEE8] px-2">
                        <p className="text-[14px]">썸네일 이미지 생성중...</p>
                        <div className="w-[136px]">
                          <ProgressBar />
                        </div>
                      </div>
                    </>
                  ))}

                <div className="flex flex-col gap-2">
                  {placIdThumbnail.map((el: ThumbnailType, index: number) => (
                    <div
                      className="relative"
                      onClick={() => {
                        setSelectedPlacIdThumbnail(el)
                        setValue('thumbnailHistoryId', el?.id)
                      }}
                    >
                      <ImageComponents
                        className="relative h-[78px] w-[138px]"
                        index={selectedPlacIdThumbnail?.id === el.id}
                        path={el.path}
                      />
                      <div className="absolute bottom-1 right-0">
                        <Controller
                          render={({ field }) => (
                            <CircularCheckbox
                              {...field}
                              id={index}
                              // checked={watch('thumbnailId') === thumbnail.id}
                              // disabled={!userInfo || !thumbnail?.usable}
                              checked={selectedPlacIdThumbnail?.id === el.id}
                              onChange={() => {}}
                            />
                          )}
                          name="thumbnailId"
                          control={control}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}
